module.exports = __webpack_public_path__ + "static/media/yardnapha-got.0b0ff452.png";